import { NgModule } from '@angular/core';
import { AccountsDataModule } from '@epicuro-next/data/accounts';
import { BasketReviewService } from '@epicuro-next/data/baskets';
import {
  BROWSER_STORAGE_SERVICE,
  BROWSER_STORAGE_TOKEN,
} from '@epicuro-next/platform/storage';
import {
  resetStateMetaReducer,
  storageMetaReducer,
} from '@epicuro-next/state/meta-reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  ACCOUNTS_CONFIG_TOKEN,
  ACCOUNTS_STORAGE_KEY,
  ACCOUNTS_STORAGE_KEYS,
} from './accounts.tokens';
import {
  accountsFeatureKey,
  initialState,
  reducer,
} from './state/accounts.reducer';
import { AccountsEffects, ActiveAccountEffects } from './state/effects';

export function getAccountsFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: BROWSER_STORAGE_SERVICE,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
      resetStateMetaReducer(initialState),
    ],
  };
}

@NgModule({
  imports: [
    AccountsDataModule,
    StoreModule.forFeature(accountsFeatureKey, reducer, ACCOUNTS_CONFIG_TOKEN),
    EffectsModule.forFeature([ActiveAccountEffects, AccountsEffects]),
  ],
  providers: [
    {
      provide: ACCOUNTS_STORAGE_KEY,
      useValue: 'accounts_storage',
    },
    {
      provide: ACCOUNTS_STORAGE_KEYS,
      useValue: ['activeAccount'],
    },
    {
      provide: ACCOUNTS_CONFIG_TOKEN,
      deps: [
        ACCOUNTS_STORAGE_KEYS,
        ACCOUNTS_STORAGE_KEY,
        BROWSER_STORAGE_TOKEN,
      ],
      useFactory: getAccountsFactoryConfig,
    },
    BasketReviewService,
  ],
})
export class AccountsStateModule {}
